import Colors from '@dynatrace/strato-design-tokens/colors';

import { INACTIVE_FILL_OPACITY_PIE_CHART_LABEL } from '../../core/constants.js';
import { LABEL_FONT_SIZE } from '../types/default.js';

export interface PieLabelProps {
  x: number;
  y: number;
  text: string;
  isHighlighted: boolean;
}

export const PieChartLabel = ({ x, y, text, isHighlighted }: PieLabelProps) => (
  <text
    fill={Colors.Text.Neutral.Default}
    x={x}
    y={y}
    fontSize={LABEL_FONT_SIZE}
    textAnchor="middle"
    pointerEvents="none"
    opacity={isHighlighted ? 1 : INACTIVE_FILL_OPACITY_PIE_CHART_LABEL}
  >
    {text}
  </text>
);
